import { showMessage } from '@app/providers/message/message';
import i18n from '@shared/services/i18n/i18n';

export const copyToClipboard = async (
  text: string,
  onSuccess?: () => void,
  onError?: (error: unknown) => void,
) => {
  const showSuccessMessage = () => {
    showMessage({
      type: 'success',
      content: i18n.t('common.notifications.copied'),
      duration: 0.5,
    });
  };

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      showSuccessMessage();
      onSuccess?.();
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      const successful = document.execCommand('copy');
      document.body.removeChild(textarea);

      if (successful) {
        showSuccessMessage();
        onSuccess?.();
      } else {
        throw new Error('document.execCommand failed');
      }
    }
  } catch (err) {
    console.error('Copy to clipboard failed:', err);
    onError?.(err);
  }
};
